"use strict";
module.exports = Object.freeze({
    STRING: 'string',
    NUMBER: 'number',
    DATE: 'date',
    ARRAY_OF_STRING: 'array-of-string',
});
//# sourceMappingURL=operandValueTypes.js.map